import { useState, useCallback, useEffect } from "react";

import { getQuestion, getImage } from "../Data";

function useQuestion({ questionID, shuffleAnswers }) {
  const shuffle = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  };

  const question = getQuestion(questionID);
  const image = getImage(question.imageID);

  const shuffledAnswers = useCallback(() => {
    let answers = Object.entries(question.answers) || [];
    if (shuffleAnswers) {
      shuffle(answers);
    }
    return answers;
  }, [shuffleAnswers, question]);

  useEffect(() => {
    setAnswers(shuffledAnswers());
  }, [shuffledAnswers]);

  const [answers, setAnswers] = useState(() => {
    return shuffledAnswers();
  });

  return { question, image, answers };
}

export default useQuestion;
